import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuthed, setIsAuthed] = useState(location.state?.user ? true : null);
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/auth/me");
        if (!cancelled) {
          setUser(res.data);
          setIsAuthed(true);
        }
      } catch {
        if (!cancelled) setIsAuthed(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Verifying session…</div>
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/login" replace />;
  return React.cloneElement(children, { user });
}
